export enum PaginationState {
  unknown = 'unknown',

  hasMore = 'hasMore',

  complete = 'complete',
}
